// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__RXULW","label":"CategoryService_label__3-GZc","location":"CategoryService_location__2NyzD"};